import React from "react";
import "./LoadingScreen.scss";
import LayoutWithSideMenu from "../../components/LayoutWithSideMenu";
import PanelInvisible from "../../components/PanelInvisible";
import Loading from "../../components/Loading";

const LoadingScreen = () => {
    return (
        <div className="loading-panel">
            <div className="loading-screen">
                <Loading />
            </div>
        </div>
    );
};

export default LoadingScreen;
